module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/07f06a48fbba576dfce5d79e6d0c3523.png";